module.exports = __webpack_public_path__ + "static/whiteroom_logo-025a017cab8674216f0d8d4d65e47b57.png";